// elements that can be used to update the page title when loaded
ht.declare('.updatePageTitle', function () {
  var oldTitle = $.trim(('' + document.title).split('-')[0]);
  document.title = oldTitle + ' - ' + $(this).text().replace(/\s+/g, ' ');
});
